<template>
    <div class="container">
        <h1>Home</h1>
        <udn-lookup class="mb-4"/>
        <hardware-device-lookup class="mb-4"/>

        <h4>Documentation Tags</h4>
        <documentation-tags />
    </div>
</template>

<script>
    import DocumenatationTags from '@/components/documentation/documentation-tags';
    import UdnLookup from '@/components/udn-device/udn-lookup';
    import HardwareDeviceLookup from '@/components/hardware-device/hardware-device-lookup';

    export default {
        components: {
            'documentation-tags': DocumenatationTags,
            'udn-lookup': UdnLookup,
            'hardware-device-lookup': HardwareDeviceLookup,
        },

        data() {
            return {};
        }
    }
</script>

<style>
</style>
